<!-- Main view when user is logged in -->
<template>
  <v-app>
    <tieto-nav-bar />

    <v-main class="ma-4">
      <router-view name="tietoview"/>
    </v-main>
    <footer-bar />
  </v-app>
</template>
<script>
import TietoNavBar from '@/components/Tieto/Menu/TietoNavBar';
import FooterBar from '@/components/Tieto/Menu/Footer';

export default {
  components: {
    TietoNavBar,
    FooterBar,
  },
  data() {
    return {
      username: '',
    };
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
